module.exports = __webpack_public_path__ + "img/water_droplet_6.47e24d27.svg";